import React from "react";

const SmallPersonIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="231"
    height="231"
    viewBox="0 0 231 231"
    fill="none"
    style={{ transform: "translateY(38px)" }}
  >
    <path
      d="M154 77C154 98.2712 136.771 115.5 115.5 115.5C94.2287 115.5 77 98.2712 77 77L78.0587 67.9525L48.125 52.9375L115.5 19.25L182.875 52.9375V101.062H173.25V57.75L152.941 67.9525L154 77ZM115.5 134.75C158.043 134.75 192.5 151.979 192.5 173.25V192.5H38.5V173.25C38.5 151.979 72.9575 134.75 115.5 134.75Z"
      fill="black"
    />
  </svg>
);

export default SmallPersonIcon;
